import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation, useParams } from "react-router";
import TopBarProgress from "react-topbar-progress-indicator";
import { createSearchParams } from "react-router-dom";
import SearchFilter from "../../../components/CustomeFilter/SearchFilter";
import { HiMiniArrowsUpDown } from "react-icons/hi2";

import {
  getAllFiltersByCategory,
  includeFiltersIntoCategory
} from "../../../actions/filters";

import CustomeTableBtn from "../../../components/custome-table-button/CustomeTableBtn";
import { Pagination } from "@mui/material";
import DashboardPagesLayout from "../customerServiceDashboard/components/DashboardPagesLayout";
import StatusButton from "./Components/StatusButton";
import FilterSortDrawer from "./Components/FilterDrawer";
import { CircularProgress } from "@mui/material";
import SortFilters from "./Components/SortFilters";
import UpdateFilterName from "./Components/UpdateFilterName";
import ViewAttribute from "./Components/ViewAttribute";

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const CreateFilter = () => {
  // hooks
  const query = useQuery();
  const id = query.get('id');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  // Local State
  const [isMount, setisMount] = useState(false);
  const [loading, setloading] = useState(true);
  const [Data, setData] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [category, setCategory] = useState({});
  const [deleteConfirm, setdeleteConfirm] = useState(false);
  const [InnderLoader, setInnderLoader] = useState(false);
  const [pagination, setpagination] = useState({
    currentPage: 1,
  });
  const [filterOption, setFilterOption] = useState([]);
  const [SearchFilterr, setSearchFilterr] = useState({
    title: "",
  });
  const [Edit, setEdit] = useState({
    open: false,
    edit: "",
    title: "",
  });
  const handleSorting = (item) => {
    setEdit({
      open: true,
      edit: "Sorting",
      title: "Sorting",
      included: { ids: selectedFilters, categoryId: id, filterOptions: Data }
    });
  };
  const handleNameChange = (name, id) => {
    setEdit({
      open: true,
      edit: "Update Name",
      title: name,
      id: id,
      name: name
    });
  };
  const handleShowAttributes = (name, id, attributes) => {
    setEdit({
      open: true,
      edit: "showAttributes",
      title: `View Attribute | ${name} | ${attributes?.length}`, //`${category.name} - ${name} - ${length}`,
      id: id,
      name: name,
      attributes: attributes
    });
  };
  // Api calls for get Order
  const getFilters = useCallback(
    async (
      id,
      pageNo,
      title,
    ) => {
      setloading(true);
      const res = await dispatch(
        getAllFiltersByCategory(
          id,
          pageNo,
          title
        )
      );
      if (res) {
        setData(res?.filters);
        setCategory(res?.category);
        setSelectedFilters(res?.category?.filter)
        const filterOptions = [];
        res.category.filter.forEach((catFilter) => {
          res?.filters.forEach((filter) => {
            if (filter._id === catFilter) {
              filterOptions.push({ _id: catFilter, title: filter.title });
            }
          });
        });
        if (filterOptions?.length) {
          setFilterOption(filterOptions);
        }
      }
      setloading(false);
    },
    [dispatch]
  );

  useEffect(() => {
    var isSubscribe = true;
    if (id && isSubscribe || !Edit.open) {
      var timer = setTimeout(() => {
        getFilters(id, pagination.currentPage, SearchFilterr.title);
      }, 1000);
    }

    return () => {
      isSubscribe = false;
      clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMount, pagination.currentPage,
    SearchFilterr.title]);

  useEffect(() => {
    var isSubscribe = true;
    if (!Edit.open) {
      var timer = setTimeout(() => {
        getFilters(id, pagination.currentPage, SearchFilterr.title);
      }, 1000);
    }

    return () => {
      isSubscribe = false;
      clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Edit.open]);


  // Reset pagination to page 1 and sync URL
  const resetToFirstPage = () => {
    setpagination((prev) => ({ ...prev, currentPage: 1 }));
    navigate(
      {
        pathname: location.pathname,
        search: `?${createSearchParams({ page: 1 })}`,
      },
      { replace: true }
    );
  };

  // handle page change
  const handleChange = (e, value) => {
    const options = {
      pathname: location.pathname,
      search: `?${createSearchParams({
        page: value,
      })}`,
    };
    navigate(options, { replace: true });
    setpagination({ ...pagination, currentPage: value });
  };
  const checkFilterShowStatus = (id) => {
    const filter = selectedFilters.find((item) => item === id);
    return filter ? true : false;
  }
  const addIntoSelectedFilters = async (filterId) => {
    const index = selectedFilters.indexOf(filterId);
    let ids = selectedFilters;
    if (index > -1) {
      setSelectedFilters(selectedFilters.filter(id => id !== filterId));
    } else {
      setSelectedFilters([...selectedFilters, filterId]);
    }
    setSelectedFilters([...selectedFilters, filterId])

    if (index > -1) {
      ids = ids.filter(id => id !== filterId);
    } else {
      ids.push(filterId);
    }
    let data = { ids, categoryId: id }
    const idsMatch = ids?.every((id, index) => id === Data[index]._id);
    if (idsMatch) {
      setFilterOption(idsMatch);
    }
    const res = await dispatch(
      includeFiltersIntoCategory(
        data
      )
    );
    if (res) {
      getFilters(id, pagination.currentPage, SearchFilterr.title);
    }
  }

  let checkPositionOfSelectedFilters = (id) => {
    const index = selectedFilters.indexOf(id);
    return index + 1;
  }
  return (
    <>
      {loading ? (
        <TopBarProgress />
      ) : (
        <>
          <div
            className=" d-flex  justify-content-end align-center flex-wrap"
            style={{ gap: "20px" }}
          >
            <SearchFilter
              type="text"
              placeholder={"Search Name"}
              value={SearchFilterr?.title}
              onChange={(e) => {
                resetToFirstPage();
                setSearchFilterr({
                  ...SearchFilterr,
                  title: e.target.value,
                });
              }}
            />


          </div>
          <div className=" my-5">
            <DashboardPagesLayout
              pageTitle={`Filters | ${category?.name}`}
              subTitle={`Total Filters: ${Data?.length}`}
              count={Data?.length}
            >
              <div className="dashboard-pages-table">
                <table>
                  <thead>
                    <tr>
                      <th>Sn#</th>
                      <th>Parent Attribute</th>
                      <th>Display Name</th>
                      <th>Position</th>
                      <th>Show / Hide</th>
                      <th>Has Custom Filter</th>
                      <th>Total Attribute</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Data?.length ? (
                      <>
                        {Data?.map((item, i) => (
                          <tr key={item?._id}>
                            <td
                              className="order-item-number"
                              onClick={() =>
                                navigate(`/admin/view-order/${item?._id}`)
                              }
                            >
                              {i + 1}
                            </td>
                            <td>{item?.attributeId?.name}</td>
                            <td>
                              <StatusButton
                                width={250}
                                status={false}
                                onClick={() => handleNameChange(item?.title, item._id)}
                              >
                                {item?.title}

                              </StatusButton>
                            </td>
                            <td>
                              <StatusButton
                                width={60}
                                status={false}
                                onClick={() => handleSorting()}
                                styles={{ padding: "8px 5px" }}
                              >
                                {checkPositionOfSelectedFilters(item._id)} <HiMiniArrowsUpDown fontSize={20} />

                              </StatusButton>
                            </td>
                            <td> <StatusButton
                              width={150}
                              status={checkFilterShowStatus(item._id)}
                              onClick={() => addIntoSelectedFilters(item._id)}
                              isCheckbox={true}
                              checked={checkFilterShowStatus(item._id)}
                            >
                              {checkFilterShowStatus(item._id) ? 'Show' : "Hide"}{" "}

                            </StatusButton></td>

                            <td> <StatusButton
                              width={100}
                              status={false}

                            // status={"Returned"}
                            >
                              {"No"}{" "}

                            </StatusButton></td>
                            <td>{item?.values?.length}</td>
                            <td>
                              <CustomeTableBtn
                                color="black"
                                width={"100px"}
                                className={"mr-2"}
                                onClick={() =>
                                  handleShowAttributes(item?.title, item._id, item?.values)
                                }
                              >
                                View Attribute
                              </CustomeTableBtn>
                            </td>
                          </tr>
                        ))}
                      </>
                    ) : (
                      <>
                        <tr>
                          <td colSpan={9} className=" text-center">
                            {" "}
                            No Record Found
                          </td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </table>
                <div>
                  <FilterSortDrawer
                    Edit={Edit}
                    setEdit={setEdit}
                  >
                    {InnderLoader ? (
                      <div className=" d-flex align-center justify-content-center">
                        <CircularProgress />
                      </div>
                    ) : (
                      <>
                        {Edit.edit === "Sorting" && (
                          <>
                            <SortFilters includedData={{ ids: selectedFilters, categoryId: id, filterOptions: filterOption }}
                              setEdit={setEdit}
                            />
                          </>
                        )}
                        {Edit.edit === "Update Name" && (
                          <>
                            <UpdateFilterName edit={Edit} setEdit={setEdit} />
                          </>
                        )}
                        {Edit.edit === "showAttributes" && (
                          <>
                            <ViewAttribute edit={Edit} setEdit={setEdit} />
                          </>
                        )}
                      </>
                    )}
                  </FilterSortDrawer>
                </div>
              </div>
            </DashboardPagesLayout>
          </div>
        </>
      )}
    </>
  );
};

export default CreateFilter;
